import React from "react";
import { Chart } from "chart.js";
import { H4, Card } from "@blueprintjs/core";
import "chartjs-adapter-date-fns";
import i18n from "../../i18n";
import { generic_colors } from "./Colors";

const Xlinear = {
  /* type: 'linear' */
};

const Xtime = {
  type: "time",
  time: {
    //unit: 'hour'
  },
};

const LineChart = class extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.labels !== undefined && this.props.data !== undefined) {
      this.myChart.data.labels = this.props.labels;
      this.myChart.data.datasets[0].data = this.props.data;
      this.myChart.update();
    } else {
      this.myChart.clear();
    }
  }

  componentDidMount() {
    this.myChart = new Chart(this.canvasRef.current, {
      type: "line",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: {
            ticks: {
              min: 0,
            },
          },
          xAxes:
            this.props.format !== undefined && this.props.format === "date"
              ? Xtime
              : Xlinear,
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x",
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: "x",
            },
            limits: {
              x: { min: "original", max: "original", minRange: 3 },
            },
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
      data: {
        labels: this.props.labels,
        datasets: [
          {
            label: this.props.title,
            data: this.props.data,
            fill: "none",
            backgroundColor: generic_colors[0],
            borderColor: generic_colors[0],
            pointRadius:
              this.props.points === undefined || this.props.points === true
                ? 3
                : 1,
            lineTension: 0.3,
          },
        ],
      },
    });
  }

  render() {
    return (
      <Card
        className={
          this.props.large !== undefined && this.props.large
            ? "big-chart-container"
            : "medium-chart-container"
        }
      >
        <H4 className="chart-title noselect">{this.props.title}</H4>
        <canvas ref={this.canvasRef} />
      </Card>
    );
  }
};

export const MultiLineChart = class extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.labels !== undefined && this.props.datasets !== undefined) {
      this.myChart.data.labels = this.props.labels;

      let i = 0;
      this.myChart.data.datasets = [];
      for (const dataset of this.props.datasets || []) {
        console.log(dataset.title);
        this.myChart.data.datasets[i] = {
          label: i18n.t(dataset.title),
          data: dataset.data,
          fill: this.props.stacked,
          backgroundColor: generic_colors[i],
          borderColor: generic_colors[i],
          pointRadius: 0,
        };
        i++;
      }

      // add max if defined and onl one line
      if (this.props.datasets.length === 1 && this.props.datasets[0]?.max > 0) {
        this.myChart.options.scales.yAxes.stacked = false;
        console.log(this.props.datasets[0]?.max);
        this.myChart.data.datasets[i] = {
          label: i18n.t("capacity"),
          data: Array(this.props.datasets[0].data.length).fill(
            this.props.datasets[0]?.max
          ),
          fill: false,
          backgroundColor: generic_colors[i],
          borderColor: generic_colors[i],
          pointRadius: 0,
        };
        i++;
      }

      if (
        this.props.datasets.length === 1 &&
        this.props.datasets[0]?.threshold > 0
      ) {
        this.myChart.data.datasets[i] = {
          label: i18n.t("saturation threshold"),
          data: Array(this.props.datasets[0].data.length).fill(
            this.props.datasets[0]?.threshold
          ),
          fill: false,
          backgroundColor: generic_colors[i],
          borderColor: generic_colors[i],
          pointRadius: 0,
        };
      }

      this.myChart.update();
    } else {
      this.myChart.clear();
    }
  }

  componentDidMount() {
    const datasets = [];
    const many_lines = this.props.datasets.length > 1;
    let i = 0;
    for (const dataset of this.props.datasets || []) {
      datasets.push({
        label: i18n.t(dataset.title),
        data: dataset.data,
        fill: this.props.stacked,
        backgroundColor: generic_colors[i],
        borderColor: generic_colors[i++],
        pointRadius: 0,
      });
      i++;
    }

    // add max if defined and onl one line
    if (i === 1 && this.props.datasets[0]?.max > 0) {
      console.log(this.props.datasets[0]?.max);
      this.myChart.data.datasets[i] = {
        label: "capacity",
        data: Array(this.props.datasets[0].data.length).fill(
          this.props.datasets[0]?.max
        ),
        fill: false,
        backgroundColor: generic_colors[i],
        borderColor: generic_colors[i],
        pointRadius: 0,
      };
    }

    this.myChart = new Chart(this.canvasRef.current, {
      type: "line",
      options: {
        animation: false,
        normalized: true,
        scales: {
          yAxes: {
            stacked: many_lines,
            ticks: {
              min: 0,
            },
          },
          xAxes:
            this.props.format !== undefined && this.props.format === "date"
              ? Xtime
              : Xlinear,
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x",
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: "x",
            },
            limits: {
              x: { min: "original", max: "original", minRange: 10 },
            },
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
      data: {
        labels: this.props.labels,
        datasets: datasets,
      },
    });
  }

  render() {
    return (
      <Card
        className={
          this.props.large !== undefined && this.props.large
            ? "big-chart-container"
            : "medium-chart-container"
        }
      >
        <H4 className="chart-title noselect">{this.props.title}</H4>
        <canvas ref={this.canvasRef} />
      </Card>
    );
  }
};

export default LineChart;
